import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-cookbook-dev/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-dev/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-dev/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-cookbook-dev/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-cookbook-dev/detail',
    method: 'get',
    params: { id }
  })
}
